import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button } from "../button";

const translations = [
    gettext('Address'),
    gettext('Zip code'),
    gettext('City'),
    gettext("Zip code missing"),
    gettext("Address missing"),
    gettext("City missing"),
    gettext("Save"),
]

const BasicAddressForm = ({ onSave, address, showSaveButton }) => {

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        setError,
        getValues,
        formState: { errors, isDirty, isValid }
    } = useForm({
        defaultValues: {
            delivery_name: address?.delivery_name,
            address_1: address?.address_1,
            address_2: address?.address_2,
            address_3: address?.address_3,
            city: address?.city,
            zip_code: address?.zip_code,
        }
    });


    return (
        <>
            <form onSubmit={handleSubmit(onSave)}>
                <div className="row">
                    <div className="col-6 mb-4">
                        <label>{gettext('Address')}</label>
                        <input type="text" {...register("address_1", { required: gettext("Address missing")})} className={`form-control ${errors.addressaddress_1 && "is-invalid"}`} />
                        {errors.address_1 && <div className="">{errors.address_1.message}</div>}
                    </div>
                    <div className="col-2 mb-4">
                        <label>{gettext('Zip code')}</label>
                        <input type="text" {...register("zip_code", { required: gettext("Zip code missing")})} className={`form-control ${errors.addresszip_code && "is-invalid"}`} />
                        {errors.zip_code && <div className="">{errors.zip_code.message}</div>}
                    </div>
                    <div className="col-4 mb-4">
                        <label>{gettext('City')}</label>
                        <input type="text" {...register("city", { required: gettext("City missing")})} className={`form-control ${errors.addresscity && "is-invalid"}`} />
                        {errors.city && <div className="">{errors.city.message}</div>}
                        
                    </div>
                </div>
                { showSaveButton && 
                    <input className="btn btn-secondary mt-4 ms-auto" type="submit" value={gettext("Save")} />
                }
            </form>
        </>
    )
}

export default BasicAddressForm